import { getStoredReturnUrl, setStoredReturnUrl } from '@/config/sourceStorage'

const BASE_PATH = import.meta.env.VITE_BASE_PATH.replace(/\/$/, '')

export const extractReturnUrlFromReferrer = referrer => {
  if (!referrer || typeof window === 'undefined') return null

  try {
    const ref = new URL(referrer)
    if (ref.origin !== window.location.origin) return null

    const path = ref.pathname.replace(/\/+$/, '') || '/'
    if (path === BASE_PATH || path.startsWith(`${BASE_PATH}/`)) return null

    return `${ref.pathname}${ref.search}`
  } catch {
    return null
  }
}

export const captureReturnUrl = queryReturnUrl => {
  if (queryReturnUrl) {
    setStoredReturnUrl(queryReturnUrl)
    return queryReturnUrl
  }

  const stored = getStoredReturnUrl()
  if (stored) return stored

  const fromReferrer = extractReturnUrlFromReferrer(
    typeof document !== 'undefined' ? (document.referrer ?? '') : ''
  )
  if (fromReferrer) {
    setStoredReturnUrl(fromReferrer)
    return fromReferrer
  }

  return null
}
